import { useEffect, useState } from 'react';
import * as serviceWorker from '../serviceWorkerRegistration';
import { Button, Snackbar } from '@mui/material';


export default function ServiceWorkerHandler() {
    const [registerWaiting, setRegisterWaiting] = useState(null);

    console.log('registerWaiting', registerWaiting);

    useEffect(() => {
        serviceWorker.register({
            onUpdate: (registration) => {
                if (registration && registration.waiting) {
                    setRegisterWaiting(registration);
                }
            }
        });
    }, []);

    const handleUpdate = () => {
        registerWaiting?.postMessage({ type: 'SKIP_WAITING' });
        setRegisterWaiting(null);
    };

    return (
        <Snackbar open={!!registerWaiting} message="New version available" action={<Button onClick={handleUpdate}>Update</Button>} />
    );
}
